export const cifLc = ["301 151","<g fill-rule='nonzero' fill='none'><path fill='#6CF' d='M.5.5h300v150H.5z'/><path fill='#FFF' d='M100.5 137.5l50-7 50 7-50-123.5z'/><path fill='#000' d='M107.25 137.5l43.25-7 43.25 7-43.25-107z'/><path fill='#FCD116' d='M100.5 137.5h100l-50-62z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-lc.js
// module id = null
// module chunks = 